import { render } from "./Carbon.vue?vue&type=template&id=5fb4756d&scoped=true"
import script from "./Carbon.vue?vue&type=script&lang=js"
export * from "./Carbon.vue?vue&type=script&lang=js"

import "./Carbon.vue?vue&type=style&index=0&id=5fb4756d&scoped=true&lang=scss"

import exportComponent from "D:\\work\\CodeV4\\FCP-Web-V4\\leanloop-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb4756d"]])

export default __exports__